module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "parentclass carousel slide",
    attrs: {
      "id": _vm.idcarousel,
      "data-ride": "carousel"
    }
  }, [_vm._t("carIndicators"), _vm._v(" "), _c('div', {
    staticClass: "carousel-inner",
    attrs: {
      "role": "listbox"
    }
  }, [_vm._t("imgslot")], 2), _vm._v(" "), (_vm.lengthban > 1) ? _c('a', {
    staticClass: "carousel-control-prev",
    attrs: {
      "href": '#' + _vm.idcarousel,
      "role": "button",
      "data-slide": "prev"
    }
  }, [_c('span', {
    staticClass: "fa fa-angle-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Previous")])]) : _vm._e(), _vm._v(" "), (_vm.lengthban > 1) ? _c('a', {
    staticClass: "carousel-control-next",
    attrs: {
      "href": '#' + _vm.idcarousel,
      "role": "button",
      "data-slide": "next"
    }
  }, [_c('span', {
    staticClass: "fa fa-angle-right",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Next")])]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28f06dd3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/carouselSlider.vue
// module id = 1081
// module chunks = 111